let host = window.location.href.split('//');
const constants = {
    // API_URL: 'http://127.0.0.1:3000/api',
    API_URL: host[0] + '//' + host[1].split('/')[0] + '/api',
}

export default constants;